export default function Contact() {
    const registerLink = (
        <a
            href="https://www.ambev.com.br/meu_cadastro"
            target="_blank"
            rel="noreferrer"
        >
            https://www.ambev.com.br/meu_cadastro
        </a>
    );

    const ambevContact = (
        <a
            href="https://www.ambev.com.br/contato"
            target="_blank"
            rel="noreferrer"
        >
            https://www.ambev.com.br/contato
        </a>
    );

    return (
        <section>
            <h2 id="contact" data-testid="contact">
                VIII. FALE CONOSCO!
            </h2>
            <p>
                O Usuário pode entrar em contato com o nosso Encarregado pelo
                Tratamento dos Dados Pessoais pelo e-mail:
                dataprivacy@ambev.com.br.
            </p>
            <p>
                Esse canal de comunicação é exclusivo para (i) sanar quaisquer
                dúvidas sobre esta Política, (ii) apresentar uma reclamação
                sobre possível violação das leis de proteção de dados e (iii)
                para atendimento de solicitações relacionadas aos seus direitos,
                conforme listado no Item VII desta Política.
            </p>
            <p>
                Para o acesso, correção de dados incompletos, inexatos ou
                desatualizados e dúvidas sobre a AMBEV, você poderá solicitar
                pelo formulário disponível em {registerLink} e em {ambevContact}
                .
            </p>
            <p>
                O Usuário fica ciente de que a exclusão das informações
                essenciais para gestão de sua conta junto à AMBEV poderá
                implicar o término de seu cadastro, com consequente cancelamento
                dos serviços então prestados.
            </p>

            <p>
                A AMBEV empreenderá todos os esforços para atender tais
                solicitações no menor tempo possível, sempre observando a
                legislação aplicável. Em alguns casos, as solicitações de
                exclusão poderão deixar de ser atendidas imediatamente, em razão
                de determinação legal.
            </p>
        </section>
    );
}
